/* eslint-disable @typescript-eslint/no-explicit-any */
// import apiLinks from "@/src/apiLinks";
import apiRoutes from "@/src/apiRoutes";
import { Button } from "@/src/components/Button/Button";
import { Modal } from "@/src/components/Modal/Modal";
import { Label, textVariants } from "@/src/components/Text/Text";
import {
  Card,
  CardContent,
  // CardDescription,
  CardHeader,
  CardTitle,
} from "@/src/components/shad/card";
import useUrlState from "@/src/hooks/use-url-state";
import api from "@/src/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { PinInput } from "@mantine/core";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Copy } from "lucide-react";
import { useForm } from "react-hook-form";
import QRCode from "react-qr-code";
import { toast } from "sonner";
import { z } from "zod";
import AppEnabled from "./AppEnabled";

const tfaState = z.object({
  code: z.string(),
});

const TFAApp = () => {
  type tfaInput = z.infer<typeof tfaState>;
  const [modal, setModal] = useUrlState("modal")

  const { setValue, getValues, handleSubmit } = useForm<tfaInput>({
    resolver: zodResolver(tfaState),
  });

  const queryClient = useQueryClient()

  // function to check enabled statuses
  const loadTfaEnabled = async () => {
    const res = await api.get(apiRoutes.tfa);

    return res?.data;
  };

  // Query to get enabled statuses
  const {
    data: otpEnabled,
    isLoading: otpEnabledLoad,
  } = useQuery({
    queryKey: ["check_tfa_enabled"],
    queryFn: loadTfaEnabled,
  });

  // function to enable two factor generally

  const handleCodeChange = (value: string) => {
    setValue("code", value);
  };

  const activate = async () => {
    const res = await api.post(apiRoutes.tfa, {
      type: "activate",
      code: getValues().code
    })
    return res.data
  }

  const { mutate, isLoading } = useMutation({
    mutationKey: ['activate_tfa'],
    mutationFn: activate,
    onSuccess: (data) => {
      if (data?.success) {
        toast.success(data?.info)
        setModal(undefined)
        queryClient.invalidateQueries({ queryKey: ['check_tfa_enabled'] })
      } else {
        toast.warning(data?.info)
      }
    }
  })

  const onSubmit = () => {
    mutate()
  }


  const copy = async (data: string) => {
    await navigator.clipboard.writeText(data);
    // notification.success({ message: "Copied to clipboard" });
    toast.success("Copied to clipboard");
  };

  if (otpEnabledLoad) return null

  if (otpEnabled?.info?.enabled) return (
    <AppEnabled />
  )

  // if (!otpEnabled?.info?.enabled)
  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle>Setup Two Factor Authentication</CardTitle>
        </CardHeader>
        <CardContent className="grid gap-5">
          <div className="flex justify-between space-x-2 items-center ">
            <div className="flex flex-col">
              <span className={textVariants()}>Secure account with authenticator app</span>
              <span className={textVariants({ size: "sm", variant: "desc" })}>
                You will need an authenticator app to complete this process.
              </span>
            </div>
            <div>
              <Button
                onClick={() => setModal('auth_app')}
                variant={"outline"}
              >Continue</Button>
            </div>
          </div>
          <div className="flex justify-between space-x-2 items-center ">
            <div className="flex flex-col">
              <span className={textVariants()}>Secure account with email</span>
              <span className={textVariants({ size: "sm", variant: "desc" })}>
                Enable two step authentication to require additional credentials
                in order to access key areas in your account
              </span>
            </div>
            <div>
              <Button
                variant={"outline"}
              >Continue</Button>
            </div>
          </div>
        </CardContent>
      </Card>
      <Modal title="Add 2FA" description="Scan the QR code with your authenticator." open={modal === "auth_app"} setOpen={(val) => setModal(val ? undefined : "auth_app")}>
        <div className="flex items-center mb-2 justify-center">
          <QRCode size={200} value={otpEnabled?.info?.scan} />
        </div>
        <div className="flex justify-center gap-2 items-center flex-col">
          <span className="p-1 text-sm rounded border flex gap-3 items-center cursor-pointer">
            <span className={textVariants()}>{otpEnabled?.info?.code}</span>{" "}
            <span onClick={() => copy(otpEnabled?.info?.code)}>
              <Copy className="h-4 w-4 text-gray-600" />
            </span>
          </span>
          <Label>Paste the code generated by your authenticator app</Label>
          <PinInput onChange={handleCodeChange} length={6} />
        </div>
        <div className="mt-5">
          <Button
            className="w-full"
            // title="Save"
            type={"submit"}
            variant="primary"
            onClick={handleSubmit(onSubmit)}
            loading={isLoading}
          >Activate</Button>

        </div>

      </Modal>
    </div>
  );
};

export default TFAApp;
